import { render } from "./SearchProductModal.vue?vue&type=template&id=221f7c7a"
import script from "./SearchProductModal.vue?vue&type=script&lang=js"
export * from "./SearchProductModal.vue?vue&type=script&lang=js"

import "./SearchProductModal.vue?vue&type=style&index=0&id=221f7c7a&lang=css"
script.render = render

export default script